(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-client-core.js', './supabase-kt-supabase-kt.js', './ktor-ktor-http.js', './supabase-kt-auth-kt.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-client-core.js'), require('./supabase-kt-supabase-kt.js'), require('./ktor-ktor-http.js'), require('./supabase-kt-auth-kt.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-functions-kt'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'supabase-kt-functions-kt'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-functions-kt'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'supabase-kt-functions-kt'.");
    }
    if (typeof globalThis['supabase-kt-supabase-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-functions-kt'. Its dependency 'supabase-kt-supabase-kt' was not found. Please, check whether 'supabase-kt-supabase-kt' is loaded prior to 'supabase-kt-functions-kt'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-functions-kt'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'supabase-kt-functions-kt'.");
    }
    if (typeof globalThis['supabase-kt-auth-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-functions-kt'. Its dependency 'supabase-kt-auth-kt' was not found. Please, check whether 'supabase-kt-auth-kt' is loaded prior to 'supabase-kt-functions-kt'.");
    }
    globalThis['supabase-kt-functions-kt'] = factory(typeof globalThis['supabase-kt-functions-kt'] === 'undefined' ? {} : globalThis['supabase-kt-functions-kt'], globalThis['kotlin-kotlin-stdlib'], globalThis['ktor-ktor-client-core'], globalThis['supabase-kt-supabase-kt'], globalThis['ktor-ktor-http'], globalThis['supabase-kt-auth-kt']);
  }
}(function (_, kotlin_kotlin, kotlin_io_ktor_ktor_client_core, kotlin_io_github_jan_tennert_supabase_supabase_kt, kotlin_io_ktor_ktor_http, kotlin_io_github_jan_tennert_supabase_auth_kt) {
  'use strict';
  //region block: imports
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Enum = kotlin_kotlin.$_$.en;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var get_SSE = kotlin_io_ktor_ktor_client_core.$_$.m;
  var MainConfig = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.q;
  var Companion_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.c;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var SupabasePluginProvider = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.v;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var bodyAsText = kotlin_io_ktor_ktor_client_core.$_$.f;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var UnknownRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.n;
  var BadRequestRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.i;
  var Companion_getInstance_0 = kotlin_io_ktor_ktor_http.$_$.j;
  var NotFoundRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.j;
  var UnauthorizedRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.m;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var authenticatedSupabaseApi = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.g;
  var resolveUrl = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.r;
  var init = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.t;
  var MainPlugin = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.s;
  var getKClass = kotlin_kotlin.$_$.si;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(FunctionRegion, 'FunctionRegion', VOID, Enum);
  initMetadataForClass(Config, 'Config', Config, MainConfig);
  initMetadataForCompanion(Companion, VOID, [SupabasePluginProvider]);
  initMetadataForCoroutine($parseErrorResponseCOROUTINE$, CoroutineImpl);
  initMetadataForClass(Functions, 'Functions', VOID, VOID, [MainPlugin], [3, 1, 0]);
  //endregion
  var FunctionRegion_ANY_instance;
  var FunctionRegion_AP_NORTHEAST_1_instance;
  var FunctionRegion_AP_NORTHEAST_2_instance;
  var FunctionRegion_AP_SOUTH_1_instance;
  var FunctionRegion_AP_SOUTHEAST_1_instance;
  var FunctionRegion_AP_SOUTHEAST_2_instance;
  var FunctionRegion_CA_CENTRAL_1_instance;
  var FunctionRegion_EU_CENTRAL_1_instance;
  var FunctionRegion_EU_WEST_1_instance;
  var FunctionRegion_EU_WEST_2_instance;
  var FunctionRegion_EU_WEST_3_instance;
  var FunctionRegion_SA_EAST_1_instance;
  var FunctionRegion_US_EAST_1_instance;
  var FunctionRegion_US_WEST_1_instance;
  var FunctionRegion_US_WEST_2_instance;
  var FunctionRegion_entriesInitialized;
  function FunctionRegion_initEntries() {
    if (FunctionRegion_entriesInitialized)
      return Unit_instance;
    FunctionRegion_entriesInitialized = true;
    FunctionRegion_ANY_instance = new FunctionRegion('ANY', 0, 'any');
    FunctionRegion_AP_NORTHEAST_1_instance = new FunctionRegion('AP_NORTHEAST_1', 1, 'ap-northeast-1');
    FunctionRegion_AP_NORTHEAST_2_instance = new FunctionRegion('AP_NORTHEAST_2', 2, 'ap-northeast-2');
    FunctionRegion_AP_SOUTH_1_instance = new FunctionRegion('AP_SOUTH_1', 3, 'ap-south-1');
    FunctionRegion_AP_SOUTHEAST_1_instance = new FunctionRegion('AP_SOUTHEAST_1', 4, 'ap-southeast-1');
    FunctionRegion_AP_SOUTHEAST_2_instance = new FunctionRegion('AP_SOUTHEAST_2', 5, 'ap-southeast-2');
    FunctionRegion_CA_CENTRAL_1_instance = new FunctionRegion('CA_CENTRAL_1', 6, 'ca-central-1');
    FunctionRegion_EU_CENTRAL_1_instance = new FunctionRegion('EU_CENTRAL_1', 7, 'eu-central-1');
    FunctionRegion_EU_WEST_1_instance = new FunctionRegion('EU_WEST_1', 8, 'eu-west-1');
    FunctionRegion_EU_WEST_2_instance = new FunctionRegion('EU_WEST_2', 9, 'eu-west-2');
    FunctionRegion_EU_WEST_3_instance = new FunctionRegion('EU_WEST_3', 10, 'eu-west-3');
    FunctionRegion_SA_EAST_1_instance = new FunctionRegion('SA_EAST_1', 11, 'sa-east-1');
    FunctionRegion_US_EAST_1_instance = new FunctionRegion('US_EAST_1', 12, 'us-east-1');
    FunctionRegion_US_WEST_1_instance = new FunctionRegion('US_WEST_1', 13, 'us-west-1');
    FunctionRegion_US_WEST_2_instance = new FunctionRegion('US_WEST_2', 14, 'us-west-2');
  }
  function FunctionRegion(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.lxa_1 = value;
  }
  function FunctionRegion_ANY_getInstance() {
    FunctionRegion_initEntries();
    return FunctionRegion_ANY_instance;
  }
  function Functions$Companion$setup$lambda($this$httpConfig) {
    $this$httpConfig.sts(get_SSE());
    return Unit_instance;
  }
  function Config() {
    MainConfig.call(this);
    this.oxa_1 = null;
    this.pxa_1 = FunctionRegion_ANY_getInstance();
    this.qxa_1 = false;
  }
  protoOf(Config).tvz = function () {
    return this.qxa_1;
  };
  function Companion() {
    Companion_instance = this;
    this.rxa_1 = 'functions';
    this.sxa_1 = Companion_getInstance().ovj('Supabase-Functions');
    this.txa_1 = 1;
  }
  protoOf(Companion).t1 = function () {
    return this.rxa_1;
  };
  protoOf(Companion).uxa = function (supabaseClient, config) {
    return new Functions(config, supabaseClient);
  };
  protoOf(Companion).xvk = function (supabaseClient, config) {
    return this.uxa(supabaseClient, config instanceof Config ? config : THROW_CCE());
  };
  protoOf(Companion).vxa = function (init) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    init(this_0);
    return this_0;
  };
  protoOf(Companion).ovl = function (init) {
    return this.vxa(init);
  };
  protoOf(Companion).wxa = function (builder, config) {
    builder.mvl(Functions$Companion$setup$lambda);
  };
  protoOf(Companion).pvl = function (builder, config) {
    return this.wxa(builder, config instanceof Config ? config : THROW_CCE());
  };
  var Companion_instance;
  function Companion_getInstance_1() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $parseErrorResponseCOROUTINE$(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fxb_1 = _this__u8e3s4;
    this.gxb_1 = response;
  }
  protoOf($parseErrorResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = bodyAsText(this.gxb_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var error = suspendResult;
            var tmp0_subject = this.gxb_1.zbq();
            return tmp0_subject.equals(Companion_getInstance_0().vt3_1) ? new UnauthorizedRestException(error, this.gxb_1) : tmp0_subject.equals(Companion_getInstance_0().yt3_1) ? new NotFoundRestException(error, this.gxb_1) : tmp0_subject.equals(Companion_getInstance_0().ut3_1) ? new BadRequestRestException(error, this.gxb_1) : new UnknownRestException(error, this.gxb_1);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function Functions(config, supabaseClient) {
    Companion_getInstance_1();
    this.hxb_1 = config;
    this.ixb_1 = supabaseClient;
    var tmp = this;
    var tmp0_elvis_lhs = this.hxb_1.oxa_1;
    tmp.jxb_1 = tmp0_elvis_lhs == null ? this.ixb_1.wvj() : tmp0_elvis_lhs;
    this.kxb_1 = authenticatedSupabaseApi(this.ixb_1, this);
  }
  protoOf(Functions).ebw = function () {
    return this.hxb_1;
  };
  protoOf(Functions).yvn = function () {
    return this.ixb_1;
  };
  protoOf(Functions).tvn = function () {
    return 1;
  };
  protoOf(Functions).uvn = function () {
    return Companion_getInstance_1().rxa_1;
  };
  protoOf(Functions).rvz = function () {
    return this.jxb_1;
  };
  protoOf(Functions).svn = function (response, $completion) {
    var tmp = new $parseErrorResponseCOROUTINE$(this, response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function get_functions(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.tvj();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPlugin' call
    var provider = Companion_getInstance_1();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPluginOrNull' call
    var tmp = tmp0.wvk_1.w2(provider.t1());
    var tmp0_elvis_lhs = tmp instanceof Functions ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Plugin ' + provider.t1() + ' not installed or not of type ' + getKClass(Functions).o() + '. Consider installing ' + getKClass(Functions).o() + ' within your SupabaseClientBuilder';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  //region block: post-declaration
  protoOf(Functions).vvn = resolveUrl;
  protoOf(Functions).odl = init;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_1;
  _.$_$.b = Functions;
  _.$_$.c = get_functions;
  //endregion
  return _;
}));

//# sourceMappingURL=supabase-kt-functions-kt.js.map
